(() => {
  'use strict';

  function init() {
    const productInfo = document.querySelector('product-info[data-main-product]');
    if (!productInfo || productInfo.dataset.restockBound) return;
    const sectionId = productInfo.dataset.section;
    const drawer = document.getElementById(`NotifyMeDrawer-${sectionId}`);
    const form = drawer?.querySelector('[data-restock-form]');
    if (!form) return;
    productInfo.dataset.restockBound = 'true';
    document.body.appendChild(drawer);
    const panel = drawer.querySelector('[role="dialog"]');
    const email = form.elements.email;
    const submit = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-restock-status]');
    const variantLabel = drawer.querySelector('[data-restock-variant]');
    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };
    let variant = null;
    let variants = [];
    let selectedOptions = [];
    let pending = false;
    let busy = false;
    let openAfterChange = false;
    let lastFocus = null;
    let confirmedVariant = null;
    let unsubscribe;
    const inactive = new Map();

    try {
      variant = JSON.parse(productInfo.querySelector('[data-selected-variant]')?.textContent || 'null');
      variants = JSON.parse(productInfo.querySelector('[data-all-variants]')?.textContent || '[]');
      selectedOptions = variant?.options?.slice() || [];
    } catch (_) {}

    const findButton = () => productInfo.querySelector('.product-form__submit');
    const soldOut = () => variant && !variant.available && variant.inventory_policy !== 'continue';

    function readSelection() {
      const picker = productInfo.querySelector('product-variant-selects');
      if (!picker) return null;
      const options = selectedOptions.slice();
      let valid = true;
      const prefix = `${sectionId}-`;
      picker.querySelectorAll('input[type="radio"]:checked, select').forEach(control => {
        const selected = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        const position = selected?.id.startsWith(prefix) && selected.id.slice(prefix.length).match(/^(\d+)-/);
        if (!position || (selected.dataset.productUrl &&
          new URL(selected.dataset.productUrl, location.origin).pathname !== new URL(productInfo.dataset.url, location.origin).pathname)) {
          valid = false;
          return;
        }
        options[Number(position[1]) - 1] = selected.value;
      });
      return valid && options.length ? options : null;
    }

    function matchesSelection(candidate, options) {
      return candidate && options && candidate.options?.length === options.length &&
        candidate.options.every((value, index) => value === options[index]);
    }

    function close(restore = true) {
      if (restore) openAfterChange = false;
      if (!drawer.classList.contains('is-open')) return;
      inactive.forEach((wasInert, element) => { element.inert = wasInert; });
      inactive.clear();
      if (restore && lastFocus?.isConnected) lastFocus.focus();
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('notify-drawer-open');
    }

    function open() {
      if (!soldOut() || drawer.classList.contains('is-open')) return;
      openAfterChange = false;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('notify-drawer-open');
      Array.from(document.body.children).forEach(element => {
        if (element !== drawer && !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName)) {
          inactive.set(element, element.inert);
          element.inert = true;
        }
      });
      email.focus({ preventScroll: true });
    }

    function showStatus(message, error = false) {
      status.textContent = message;
      status.hidden = false;
      status.classList.toggle('notify-form__status--error', error);
    }

    function updateSubmit() {
      const confirmed = confirmedVariant !== null && String(variant?.id) === confirmedVariant;
      submit.disabled = busy || !soldOut() || confirmed;
      submit.textContent = busy ? form.dataset.sendingText :
        confirmed ? form.dataset.receivedText : form.dataset.submitText;
    }

    function update() {
      const button = findButton();
      const notify = soldOut();
      if (button) {
        button.classList.toggle('product-form__submit--notify-me', Boolean(notify));
        if (notify) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          const text = button.querySelector('span');
          if (text) {
            text.textContent = form.dataset.notifyText;
            text.classList.remove('hidden');
          }
          button.querySelector('.sold-out-message')?.classList.add('hidden');
        }
      }
      const preorder = button?.closest('product-form')?.hasAttribute('data-has-pre-order');
      productInfo.querySelectorAll('.product-form__dynamic-checkout, .shopify-payment-button, .product-form__buy-now').forEach(element => {
        element.style.display = notify || preorder ? 'none' : '';
      });
      if (variant) variantLabel.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (String(variant?.id) !== String(confirmedVariant)) {
        status.hidden = true;
        status.textContent = '';
      }
      updateSubmit();
      if (!notify) close(false);
    }

    email.addEventListener('input', () => {
      if (busy) return;
      confirmedVariant = null;
      status.hidden = true;
      status.textContent = '';
      updateSubmit();
    }, listenerOptions);

    productInfo.addEventListener('change', event => {
      if (!event.target.closest('product-variant-selects')) return;
      pending = true;
      const options = readSelection();
      variant = variants.find(candidate => matchesSelection(candidate, options)) || null;
      if (options) selectedOptions = options;
      confirmedVariant = null;
      openAfterChange = !variant;
      close(false);
      update();
      if (soldOut()) open();
      queueMicrotask(() => { if (soldOut()) update(); });
    }, { capture: true, signal: controller.signal });

    productInfo.addEventListener('click', event => {
      const button = event.target.closest('.product-form__submit');
      if (button && (pending || soldOut())) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (soldOut()) open();
      }
      const label = event.target.closest('.product-option__label');
      const input = label && document.getElementById(label.htmlFor);
      if (input?.checked && soldOut()) open();
    }, { capture: true, signal: controller.signal });

    productInfo.addEventListener('submit', event => {
      if (pending || soldOut()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (soldOut()) open();
      }
    }, { capture: true, signal: controller.signal });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data?.sectionId !== sectionId) return;
        const incoming = event.data.variant || null;
        if (incoming && selectedOptions.length && !matchesSelection(incoming, selectedOptions)) return;
        if (String(variant?.id) !== String(incoming?.id)) confirmedVariant = null;
        variant = incoming;
        if (variant) {
          selectedOptions = variant.options.slice();
          variants = variants.filter(candidate => String(candidate.id) !== String(variant.id));
          variants.push(variant);
        }
        pending = false;
        update();
        if (openAfterChange && soldOut()) open();
        openAfterChange = false;
      });
    }

    drawer.querySelectorAll('[data-notify-drawer-close]').forEach(element => {
      element.addEventListener('click', event => { event.preventDefault(); close(); }, listenerOptions);
    });
    drawer.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]')).filter(element => element.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }, listenerOptions);

    let startY = null;
    const header = drawer.querySelector('.notify-me-drawer__header');
    header.addEventListener('touchstart', event => {
      if (window.innerWidth < 750) startY = event.touches[0].clientY;
    }, { passive: true, signal: controller.signal });
    header.addEventListener('touchend', event => {
      if (startY !== null && event.changedTouches[0].clientY - startY > 80) close();
      startY = null;
    }, listenerOptions);

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      email.value = email.value.trim();
      if (!form.reportValidity()) return;
      if (!soldOut() || !matchesSelection(variant, readSelection())) {
        showStatus(form.dataset.variantError, true);
        return;
      }
      const requestedVariant = String(variant.id);
      if (confirmedVariant === requestedVariant) return;
      if (form.dataset.preview !== 'false') {
        confirmedVariant = requestedVariant;
        showStatus(form.dataset.previewText);
        updateSubmit();
        status.focus();
        return;
      }
      busy = true;
      submit.disabled = true;
      email.readOnly = true;
      submit.textContent = form.dataset.sendingText;
      form.setAttribute('aria-busy', 'true');
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 15000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${encodeURIComponent(form.dataset.companyId)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
          signal: request.signal,
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email.value } } },
                channels: ['EMAIL']
              },
              relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${requestedVariant}` } } }
            }
          })
        });
        if (response.status !== 202) throw new Error('Restock request not accepted');
        confirmedVariant = requestedVariant;
        if (String(variant?.id) === requestedVariant) {
          showStatus(form.dataset.successText);
          status.focus();
        }
      } catch (_) {
        if (String(variant?.id) === requestedVariant) showStatus(form.dataset.errorText, true);
      } finally {
        clearTimeout(timeout);
        busy = false;
        email.readOnly = false;
        updateSubmit();
        form.removeAttribute('aria-busy');
      }
    }, listenerOptions);

    document.addEventListener('shopify:section:unload', event => {
      if (event.detail?.sectionId !== sectionId) return;
      close(false);
      controller.abort();
      unsubscribe?.();
      drawer.remove();
    }, listenerOptions);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
